import React, {useEffect} from 'react';
import {useParams} from "react-router-dom";
import useLoadSpace from "../hooks/useLoadSpace";
import Loading from "../scenes/Loading";
import PostEvent from "../scenes/PostEvent";
import PreEvent from "../scenes/PreEvent";
import Watch from "../scenes/Watch";
import Guest from "./Guest";
import useValidateAuth from "../hooks/useValidateAuth";
import Diagnose from "../scenes/Diagnose";
import {useRecoilValue} from "recoil";
import hasDiagnosedState from "../state/hasDiagnosedState";
import firebaseApp from "../services/firebase";
import LimitedLogin from '../scenes/LimitedLogin';
import loggedOutState from "../state/loggedOutState";
import useFetchTheatron from "../hooks/useFetchTheatron";

const Space = () => {
  const timing = useLoadSpace();
  const valid = useValidateAuth();
  const hasDiagnosed = useRecoilValue(hasDiagnosedState);
  const loggedOut = useRecoilValue(loggedOutState);
  const theatron = useFetchTheatron();

  useEffect(() => {
    if(!theatron?.data?.id || !timing.data?.venue?.theatron?.id) {
      return;
    }

    if(theatron.data.id !== timing.data.venue.theatron.id) {
      window.location = timing.data.watch_url;
    }
  }, [theatron?.data?.id, timing.data?.venue?.theatron?.id]);

  if(timing.isLoading || (timing.isFetched && !timing.state.id) || !valid.isFetched) {
    return <Loading />
  }
  else if(timing.isFetched) {
    if(valid.data && !loggedOut) {
      return <Watch />;
      // return hasDiagnosed ? <Watch /> : <Diagnose />;
    }
    else if(timing.state.isClosed) {
      return <PostEvent />
    }
    else if(timing.state.isOpen) {
      return <Guest />;
    }
    else {
      return <PreEvent />;
    }
  }
  else {
    return <Loading error={true} />
  }
}

export default Space;
